module.exports = __webpack_public_path__ + "images/emoji/beetle.aaf407bce9ea23f1abdf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/beetle.png
// module id = DG8m
// module chunks = 14